// src/Assets/Components/Header.js

import './Header.css';
import logo from '../Images/alvesrms_512.png';
import {ReactComponent as LinkedInLogo} from '../Images/logo_linkedin.svg';
import {ReactComponent as ResearchGateLogo} from '../Images/logo_researchgate.svg';
import {ReactComponent as OrcidLogo} from '../Images/logo_orcid.svg';
import {ReactComponent as GitHubLogo} from '../Images/logo_github.svg';
import {ReactComponent as StackOverflowLogo} from '../Images/logo_stackoverflow.svg';
import {ReactComponent as GISStackLogo} from '../Images/logo_gisstack.svg';
import {ReactComponent as EmailButton} from '../Images/button_email.svg';
import {ReactComponent as CalendlyLogo} from '../Images/logo_calendly.svg';


const Header = () => {
  return (
    <header className='header'>

      <div className='header-left'>
        <a href='/' title = 'Home'>
          <img src={logo} alt='Renata Alves' className='main-logo' />
        </a>
        <div className='header-title'>Renata M. S. Alves, Phd</div>
      </div>

      <div className = 'header-center'>
        <a href='https://www.linkedin.com/in/alvesrms' title = 'LinkedIn' target="_blank" rel="noopener noreferrer">
          <LinkedInLogo className='svg-logo' />
        </a>
        <a href='https://www.researchgate.net/profile/Renata-Alves-4' title = 'Research Gate' target="_blank" rel="noopener noreferrer">
          <ResearchGateLogo className='svg-logo' />
        </a>
        <a href='https://orcid.org/0000-0002-8422-0611' title = 'ORCID' target="_blank" rel="noopener noreferrer">
          <OrcidLogo className='svg-logo' />
        </a>
        <a href='https://gis.stackexchange.com/users/63519/renata-msa' title = 'GIS Stack Exchange' target="_blank" rel="noopener noreferrer">
          <GISStackLogo className='svg-logo' />
        </a>
        <a href='https://github.com/alvesrms-bio' title = 'GitHub' target="_blank" rel="noopener noreferrer">
          <GitHubLogo className='svg-logo' />
        </a>
        <a href='https://stackoverflow.com/users/5519423/renata-msa' title = 'Stack Overflow' target="_blank" rel="noopener noreferrer">
          <StackOverflowLogo className='svg-logo' />
        </a>
      </div>

      <div className='header-right'>
        <a href='mailto:alvesrms.bio@gmail.com' title = 'Email Me' target="_blank" rel="noopener noreferrer">
          <EmailButton className='svg-logo' />
        </a>
        <a href='https://calendly.com/alvesrms-bio/call-with-renata-ms-alves-phd' title = 'Schedule a Call' target="_blank" rel="noopener noreferrer">
          <CalendlyLogo className='svg-logo' />
        </a>
    </div>

    </header>
  );
};

export default Header;